const PERCENT_SUFFIX = /\s*%$/;

const capitalised = (label: string): string => label.charAt(0).toUpperCase() + label.slice(1);

export function metricSentence(label: string, value: number): string {
  if (!PERCENT_SUFFIX.test(label)) {
    return `${value} ${label}`;
  }

  return `${capitalised(label.replace(PERCENT_SUFFIX, ''))} ${value}%`;
}
